import { render, staticRenderFns } from "./courseCardDesc.vue?vue&type=template&id=decc34b6&scoped=true&"
import script from "./courseCardDesc.vue?vue&type=script&lang=js&"
export * from "./courseCardDesc.vue?vue&type=script&lang=js&"
import style0 from "./courseCardDesc.vue?vue&type=style&index=0&id=decc34b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decc34b6",
  null
  
)

export default component.exports